module.exports = __webpack_public_path__ + "media/application/images/svgs/chevron-left-2124840d8bd56d61a2b8ae8df8f688cf.svg";